// Browser session authentication uses only the HttpOnly cookie.

/** Legacy key: remove it, but never read it as a credential. */
export const SESSION_TOKEN_KEY = "zoe.session";

/** Remove old session IDs from both stores, including when one is disabled. */
export function clearLegacySessionStorage(): void {
  if (typeof window === "undefined") return;
  for (const name of ["localStorage", "sessionStorage"] as const) {
    try {
      window[name].removeItem(SESSION_TOKEN_KEY);
    } catch {
      // Storage can be disabled. Cookie authentication does not need it.
    }
  }
}

// Run before the app mounts, even on pages that make no API request.
clearLegacySessionStorage();

/** The existing CSRF marker; fetch supplies the cookie and browser Origin. */
export function sessionRequestHeaders(): Record<string, string> {
  clearLegacySessionStorage();
  return { "X-Zoe-Csrf": "1" };
}
